import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import FormField from "../../../../products/new-product/components/FormField";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../../../../../components/MDInput";
import countryOptions from "../../components/List/Countries";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import axios from "axios";
import { GlobalWorkerOptions } from "pdfjs-dist";
import { useNavigate } from "react-router-dom";
import CrudService from "services/cruds-service";
import "jspdf-autotable";
import jsonData from "../../../../../../assets/dataSultantur.json";
import {  IconButton, Modal,  } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.js`;

const Sultantur = ({ selectedCarrier }) => {
    const navigate = useNavigate();
    const initialAddressState = {
        additionalInfo: "",
        country: "",
        zipcode: "",
    };

    const [cargoDetails, setCargoDetails] = useState([
        {
            unitQuantity: "",
            width: "",
            length: "",
            height: "",
            volume: "",
            grossWeight: "",
            notStackable: true,
            stackingFactor: 2,
            cbm: 0,
            ldm: 0,
            chargeableWeight: 0,
            description: "",
        },
    ]);

    const [loading, setLoading] = useState(false); // Yüklenme durumu
    const [isEditing, setIsEditing] = useState(false); // Düzenleme modu
    const searchParams = new URLSearchParams(location.search); // Query parametrelerini yakalıyoruz
    const spotQuotingToolId = searchParams.get("id"); // URL'deki `id` parametresini alıyoruz

    const [pickupLocation, setPickupLocation] = useState({
        additionalInfo: "",
        country: "",
        zipcode: "",
        warehouse: "Mersin", // ✅ Varsayılan olarak "Mersin"
    });
    // 🚀 Hesaplama Fonksiyonları
    const calculateCBM = (length, width, height, unitQuantity) => ((length * width * height * unitQuantity) / 1000000).toFixed(3);

    function calculateLDM(length, width, unitQuantity, notStackable, stackingFactor) {
        const tirWidth = 2.4; // Kamyon genişliği
        const totalVolume = (length * width * unitQuantity) / tirWidth / 10000; // Hacim hesabı

        // Eğer notStackable ise, istiflenmediği için toplam hacmi döndür
        if (notStackable) {
            return totalVolume;
        } else {
            // İstifleniyorsa stackingFactor ile böl
            return totalVolume / stackingFactor;
        }
    }

    const calculateChargeableWeight = (ldm, cbm, grossWeight, operationType) => {
        const volumeWeight = cbm * (operationType === "air" ? 167 : 333);
        return Math.max(volumeWeight, grossWeight).toFixed(2);
    };


    const [mersinPickupLocation, setMersinPickupLocation] = useState({
        linehaulCost: "",
        currency: "",
        perkgs: "",
        cost: "",
        totalCost: "",
    });


    // 📌 Toplam Chargeable Weight hesapla
    const totalChargeableWeight = cargoDetails.reduce((sum, c) => sum + (parseFloat(c.chargeableWeight) || 0), 0);

// 📌 Mersin için hesaplama
    useEffect(() => {
        if (mersinPickupLocation.linehaulCost && totalChargeableWeight > 0) {
            const cost = (totalChargeableWeight * (mersinPickupLocation.linehaulCost / 23625)).toFixed(2);
            setMersinPickupLocation((prev) => ({
                ...prev,
                perkgs: (prev.linehaulCost / 23625).toFixed(2),
                cost: parseFloat(cost),
            }));
        }
    }, [mersinPickupLocation.linehaulCost, totalChargeableWeight]);


    const [selectedWarehouse, setSelectedWarehouse] = useState("Mersin"); // Varsayılan Mersin

    useEffect(() => {
        if (isEditing && pickupLocation.warehouse) {
            setSelectedWarehouse(pickupLocation.warehouse); // 🚀 Eğer düzenleme modundaysa veritabanındaki değeri set et
        }
    }, [isEditing, pickupLocation.warehouse]);

    const [formData, setFormData] = useState({

        unitQuantity: "",
        width: "",
        length: "",
        height: "",
        volume: "",
        grossWeight: "",
        stackable: false,
        stackingFactor: "",
        cbm: "",
        ldm: "",
        chargeableWeight: "",
        description: "",
        pickupLocation: "",
        selectedCarrier: selectedCarrier, // İlk başta CreateQuotingTool'dan gelen değer atanır
    });


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            selectedCarrier: selectedCarrier,
        }));
    }, [selectedCarrier]);

    // Eğer spotQuotingToolId varsa düzenleme modundayız ve veriyi çekiyoruz
    useEffect(() => {
        if (spotQuotingToolId) {
            setIsEditing(true); // Düzenleme modunu etkinleştiriyoruz
            fetchSpotQuotingToolDetails(spotQuotingToolId); // SpotQuotingTool detaylarını çekiyoruz
        }
    }, [spotQuotingToolId]);

    const fetchSpotQuotingToolDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getSpotQuotingToolById(id);
            const spotQuotingToolData = response.data.attributes;

            setSpotId(spotQuotingToolData.SpotId || "Unknown");
            setUnit(spotQuotingToolData.unit || "");
            setCargoDetails(spotQuotingToolData.cargoDetails || []);

            if (spotQuotingToolData.pickupLocation) {
                setPickupLocation({
                    additionalInfo: spotQuotingToolData.pickupLocation.additionalInfo || "",
                    country: spotQuotingToolData.pickupLocation.country || "",
                    zipcode: spotQuotingToolData.pickupLocation.zipcode || "",
                    warehouse: spotQuotingToolData.pickupLocation.warehouse || "",
                });
            }

            if (spotQuotingToolData.mersinPickupLocation) {
                setMersinPickupLocation({...spotQuotingToolData.mersinPickupLocation});
            }

            setFormData((prevState) => ({
                ...prevState,
                unitQuantity: spotQuotingToolData.unitQuantity,
                width: spotQuotingToolData.width,
                length: spotQuotingToolData.length,
                height: spotQuotingToolData.height,
                volume: spotQuotingToolData.volume,
                grossWeight: spotQuotingToolData.grossWeight,
                stackable: spotQuotingToolData.stackable,
                stackingFactor: spotQuotingToolData.stackingFactor,
                cbm: spotQuotingToolData.cbm,
                ldm: spotQuotingToolData.ldm,
                chargeableWeight: spotQuotingToolData.chargeableWeight,
                description: spotQuotingToolData.description,
                selectedCarrier: spotQuotingToolData.selectedCarrier,
            }));

        } catch (error) {
            console.error("Error fetching spotQuotingTool details:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (spotQuotingToolId) {
            fetchSpotQuotingToolDetails(spotQuotingToolId); // Belirli bir `spotQuotingToolId`'ye göre veriyi yükler
        }
    }, [spotQuotingToolId]);


    const [width, setWidth] = useState("");
    const [length, setLength] = useState("");
    const [height, setHeight] = useState("");
    const [volume, setVolume] = useState("");
    const [grossWeight, setGrossWeight] = useState("");
    const [ldm, setLdm] = useState(0);
    const [cbm, setCbm] = useState(0); // CBM state added
    const [chargeableWeight, setChargeableWeight] = useState(0); // Chargeable Weight state added
    const [notStackable, setNotStackable] = useState(true); // Default olarak Not Stackable true
    const [stackingFactor, setStackingFactor] = useState(2); // Stacking Factor
    const [operationType, setOperationType] = useState("road"); // Operation type (road, sea, air, rail)
    const [unit, setUnit] = useState("");
    const [spotId, setSpotId] = useState(""); // Yeni spotId state'i

    // Pickup Address State'leri
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [zipcodeOptions, setZipcodeOptions] = useState([]);
    const [zipcodeError, setZipcodeError] = useState(false);
    const [showAddressDetails, setShowAddressDetails] = useState(false);
    const [isZipcodeListOpen, setIsZipcodeListOpen] = useState(false);

    const [calculatedZone, setCalculatedZone] = useState(""); // Hesaplanan zone
    const [calculatedRate, setCalculatedRate] = useState(""); // Hesaplanan rate



    // Generic state handler
    const handleStateChange = (setter, key, value) => {
        setter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };


    const allowedCountries = ["DE", "IT", "NL", "BE"];

    const filteredCountryOptions = countryOptions.filter(country =>
        allowedCountries.includes(country.code)
    );

    // Formül hesaplamalarını otomatik hale getirmek için useEffect kullanımı
    useEffect(() => {
        // Eğer gerekli veriler mevcutsa, hesaplamaları yap ve state'leri güncelle
        if (width && length && height && unit) {
            const calculatedVolume = calculateCBM(length, width, height, unit); // CBM hesaplama
            setVolume(calculatedVolume);

            const calculatedLdm = calculateLDM(
                length,
                width,
                unit,
                notStackable,
                stackingFactor,
            ); // LDM hesaplama
            setLdm(calculatedLdm);

            const calculatedCbm = calculateCBM(length, width, height, unit); // CBM hesaplama
            setCbm(calculatedCbm);

            const calculatedChargeableWeight = calculateChargeableWeight(
                calculatedLdm,
                calculatedCbm,
                grossWeight,
                operationType,
            ); // Chargeable Weight hesaplama
            setChargeableWeight(calculatedChargeableWeight);
        } else {
            // Eğer veriler eksikse, tüm değerleri sıfırla
            setVolume();
            setLdm(0);
            setCbm(0);
            setChargeableWeight(0);
        }
    }, [
        width,
        length,
        height,
        unit,
        grossWeight,
        notStackable,
        stackingFactor,
        operationType,
    ]);

    // Zipcode API işlemi
    const fetchZipcodeOptions = async (zipcode, countryCode, setOptions, setError, setOpen,) => {
        try {
            if (!countryCode || !zipcode) return;

            const response = await axios.get(
                `https://api.zippopotam.us/${countryCode}/${zipcode}`,
            );
            const places = response.data.places.map((place) => ({
                label: `${place["place name"]}, ${place["state"]} (${place["longitude"]}, ${place["latitude"]})`,
                city: place["place name"],
                district: place["state"],
                country: response.data.country,
                latLong: `${place["latitude"]}, ${place["longitude"]}`,
            }));
            setOptions(places);
            setError(false);
            setOpen(true);
        } catch {
            setOptions([]);
            setError(true);
            setOpen(false);
        }
    };

    const handleZipcodeChange = (e, selectedCountry, setAddress, setOptions, setError, setOpen,) => {
        const inputZipcode = e.target.value;

        // Zipcode boşaltıldığında diğer alanları da temizle
        if (!inputZipcode) {
            setAddress(initialAddressState); // Diğer alanları temizliyoruz
            setOptions([]);
            setError(false);
            setOpen(false);
            return;
        }

        if (inputZipcode.length >= 3 && selectedCountry) {
            fetchZipcodeOptions(
                inputZipcode,
                selectedCountry.code.toLowerCase(),
                setOptions,
                setError,
                setOpen,
            );
        } else {
            setOptions([]);
            setError(false);
            setOpen(false);
        }
        handleStateChange(setAddress, "zipcode", inputZipcode);
    };

    const handleZipcodeSelect = (value, setAddress, setOpen, setShowDetails) => {
        if (value) {
            setAddress((prevState) => ({
                ...prevState,
                city: value.city,
                district: value.district,
                country: value.country, // Ülke bilgisi otomatik doldurulacak
                latLong: value.latLong,
            }));
            setSelectedCountry(
                filteredCountryOptions.find((option) => option.label === value.country)
            );
            setOpen(false);
            setShowDetails(true);
        } else {
            setAddress((prevState) => ({
                ...prevState,
                country: "", // Zipcode seçilmezse ülkeyi boş bırak
            }));
        }
    };

    useEffect(() => {
        if (pickupLocation.country) {
            const matchedCountry = filteredCountryOptions.find(
                (country) => country.label === pickupLocation.country
            );

            if (matchedCountry) {
                setSelectedCountry(matchedCountry);
            }
        }
    }, [pickupLocation.country]);


    const updateCargoDetails = (index, field, value) => {
        const updatedCargo = [...tempCargoDetails];
        updatedCargo[index][field] = value || 0;

        const {
            width,
            length,
            height,
            unitQuantity,
            grossWeight,
            notStackable,
            stackingFactor,
            operationType
        } = updatedCargo[index];

        const volume = calculateCBM(length, width, height, unitQuantity);
        const ldm = calculateLDM(length, width, unitQuantity, notStackable, stackingFactor);
        const cbm = calculateCBM(length, width, height, unitQuantity);
        const chargeableWeight = calculateChargeableWeight(ldm, cbm, grossWeight, operationType);

        updatedCargo[index] = {...updatedCargo[index], volume, ldm, cbm, chargeableWeight};
        setTempCargoDetails(updatedCargo);
    };

    // 📌 useEffect ile Otomatik Hesaplama
    useEffect(() => {
        setCargoDetails(cargoDetails.map((cargo) => ({
            ...cargo,
            volume: calculateCBM(cargo.length, cargo.width, cargo.height, cargo.unitQuantity),
            ldm: calculateLDM(cargo.length, cargo.width, cargo.unitQuantity, cargo.notStackable, cargo.stackingFactor),
            cbm: calculateCBM(cargo.length, cargo.width, cargo.height, cargo.unitQuantity),
            chargeableWeight: calculateChargeableWeight(
                calculateLDM(cargo.length, cargo.width, cargo.unitQuantity, cargo.notStackable, cargo.stackingFactor),
                calculateCBM(cargo.length, cargo.width, cargo.height, cargo.unitQuantity),
                cargo.grossWeight,
                cargo.operationType
            ),
        })));
    }, [cargoDetails]);

    // Submit işlemi için gerekli fonksiyon

    const submitHandler = async (e) => {
        e.preventDefault();
        // Validation - Required fields

        const updatedMersinPickupLocation = {
            ...mersinPickupLocation,
            calculatedZone,
            calculatedRate,
            totalCost: parseFloat(mersinPickupLocation.cost || 0) + parseFloat(mersinPickupLocation.calculatedRate || 0),
        };

        const spotQuotingToolData = {
            SpotId: undefined, // Eğer frontend gönderirse, backend null kaydetmesin
            cargoDetails,
            operationType,
            pickupLocation: {
                ...pickupLocation,
                warehouse: selectedWarehouse, // ✅ Seçilen warehouse backend'e gönderilecek
            },
            mersinPickupLocation: updatedMersinPickupLocation,
            selectedCarrier // DB'ye kaydedilecek
        };
        try {
            setLoading(true);

            if (isEditing) {
                const response = await CrudService.updateSpotQuotingTool(
                    spotQuotingToolData,
                    spotQuotingToolId,
                );
            } else {
                const response = await CrudService.createSpotQuotingTool({
                    data: spotQuotingToolData,
                });
            }
            navigate("/spot-quoting-tool/spot-quoting-tool-tables/details", {
                state: {
                    value: true,
                    text: isEditing
                        ? "The Spot Quote was successfully updated"
                        : "The Spot Quote was successfully created",
                },
            });

        } catch (err) {
            console.error("İstek başarısız oldu: ", err);
        } finally {
            setLoading(false);
        }
    };


    // Calculate Cost whenever chargeableWeight or perkgs changes
    useEffect(() => {
        // Calculate the cost using only the first chargeableWeight value
        const firstChargeableWeight = cargoDetails[0]?.totalChargeableWeight || 0; // Use 0 if undefined
        const calculatedCost = firstChargeableWeight * pickupLocation.perkgs;
        setPickupLocation((prev) => ({
            ...prev,
            cost: parseFloat(calculatedCost.toFixed(2)),
        }));
    }, [cargoDetails, pickupLocation.perkgs]);


    const calculateZoneAndRate = () => {
        if (!selectedCountry || !pickupLocation.zipcode || totalChargeableWeight === 0) {
            console.error("Lütfen ülke, posta kodu ve ücretlendirilir ağırlık değerlerini giriniz.");
            return;
        }

        // Ülke JSON verisini kontrol et
        const countryData = jsonData.countries[selectedCountry.code];
        if (!countryData) {
            console.error("Ülke bilgisi bulunamadı:", selectedCountry.code);
            return;
        }

        // Zones ve Rates objeleri var mı kontrol et
        if (!countryData.zones || !countryData.rates) {
            console.error(`"${selectedCountry.code}" için zone veya rate bilgisi bulunamadı.`);
            return;
        }

        // Zipcode’un ilk 2 hanesini al ve zone belirle
        const zipPrefix = parseInt(pickupLocation.zipcode.slice(0, 2));

        let zone = Object.keys(countryData.zones).find((key) =>
            countryData.zones[key].includes(zipPrefix)
        ) || "Zone Not Found";

        if (zone === "Zone Not Found") {
            console.error(`Bu posta kodu (${pickupLocation.zipcode}) için zone bulunamadı.`);
            return;
        }
        // Eğer rates[zone] bulunamazsa hata vermek yerine varsayılan bir rate belirle
        const rates = countryData.rates[zone];
        if (!rates) {
            console.error(`"${zone}" için rate bilgisi bulunamadı.`);
            return;
        }

        // ✅ **Minimum Rate Tanımları (Statik olarak kod içinde belirliyoruz)**
        const minRateMapping = {
            "DE": {
                "Zone 0": 400, "Zone 1": 400, "Zone 2": 400,
                "Zone 3": 330, "Zone 4": 330, "Zone 5": 330,
                "Zone 6": 300, "Zone 7": 300, "Zone 8": 300, "Zone 9": 300
            },
            "IT": {
                "Zone 1": 250, "Zone 5": 250,
                "Zone 2": 230, "Zone 3": 230, "Zone 4": 230,
                "Zone 6": 300
            },
            "BE": {"Zone 1": 350},
            "NL": {"Zone 1": 350}
        };

        // Ülke ve zone için minimum rate belirleme
        const minRate = minRateMapping[selectedCountry.code]?.[zone] || 0; // Eğer belirtilmemişse 0 alır.

        // ✅ **Toplam Chargeable Weight’e göre en uygun rate belirle**
        const weight = totalChargeableWeight;
        const weightRanges = [1000, 2000, 3000, 5000, 7500, 10000];

        let rate = rates[rates.length - 1]; // Varsayılan olarak en düşük rate al
        for (let i = 0; i < weightRanges.length; i++) {
            if (weight <= weightRanges[i]) {
                rate = rates[i];
                break;
            }
        }

        // ✅ **Minimum Rate Kontrolü**
        const calculatedTotalRate = weight * rate;
        const finalRate = Math.max(calculatedTotalRate, minRate);

        // ✅ **Hesaplanan değerleri state'e kaydet**
        setCalculatedZone(zone);
        setCalculatedRate(finalRate);
    };

    // 📌 Ülke değiştiğinde, yeni zone ve rate hesaplanmalı
    useEffect(() => {
        if (selectedCountry) {
            calculateZoneAndRate(); // 🚀 Sadece ülke değişince hesapla
        }
    }, [selectedCountry]);

// 📌 Posta kodu ve ağırlık değiştiğinde hesaplama yap
    useEffect(() => {
        if (selectedCountry && pickupLocation.zipcode && totalChargeableWeight > 0) {
            calculateZoneAndRate();
        }
    }, [pickupLocation.zipcode, totalChargeableWeight]);


// Otomatik hesaplama için useEffect
    useEffect(() => {
        if (selectedCountry && pickupLocation.zipcode && cargoDetails[0]?.totalChargeableWeight) {
            calculateZoneAndRate();
        }
    }, [selectedCountry, pickupLocation.zipcode, cargoDetails]); // Bu bağımlılık listesi değiştiğinde tetiklenecek


    const [totalCostMersin, setTotalCostMersin] = useState(0);


    useEffect(() => {
        // Eğer Mersin veya İstanbul'da maliyet değişirse totalCost'u güncelle
        const mersinCost = parseFloat(mersinPickupLocation.cost) || 0;
        const rate = parseFloat(calculatedRate) || 0;

        setTotalCostMersin(mersinCost + rate);
    }, [
        mersinPickupLocation.cost,
        calculatedRate
    ]);


    useEffect(() => {
        if (pickupLocation.country) {
            const matchedCountry = filteredCountryOptions.find(
                (country) => country.label === pickupLocation.country
            );

            if (matchedCountry) {
                setSelectedCountry(matchedCountry);
            }
        }
    }, [pickupLocation.country]);

    const handleCountryChange = (newValue) => {
        setSelectedCountry(newValue);

        setPickupLocation((prev) => ({
            ...prev,
            country: newValue ? newValue.label : "",
        }));
    };

    useEffect(() => {
        if (!pickupLocation.warehouse) {
            setPickupLocation((prev) => ({
                ...prev,
                warehouse: "",
            }));
        }
    }, []);


    const [modalOpen, setModalOpen] = useState(false);
    const [tempCargoDetails, setTempCargoDetails] = useState([...cargoDetails]);


    // 📌 Modal açıldığında tempCargoDetails'i güncelle
    useEffect(() => {
        if (modalOpen) {
            setTempCargoDetails([...cargoDetails]); // Kayıtlı verileri yedekle
        }
    }, [modalOpen]); // modalOpen değiştiğinde çalışır


    return (
        <Grid container spacing={0} justifyContent="center" mb={1}>
            <Grid item xs={12} lg={10}>
                <MDBox mb={2}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12}>
                        <MDBox mb={1} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    {isEditing
                                        ? " Edit Control Tower Tool Details"
                                        : " Add Control Tower Tool Details"}
                                </MDTypography>
                            </MDBox>
                            <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                This information will describe more about the Control Tower Tool.
                            </MDTypography>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
                <MDBox mt={3}
                       sx={{
                           p: 3,
                           borderRadius: "10px",
                           bgcolor: "background.paper",
                           boxShadow: "none",
                       }}>
                    <MDBox mb={3}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox>
                                {/* Spot ID sadece düzenleme modunda gösterilecek */}
                                {isEditing && (
                                    <Grid container spacing={3} alignItems="center">
                                        <Grid item>
                                            <MDTypography variant="h6" fontWeight="regular">
                                                SpotQuotingTool ID: <strong>{spotId}</strong>
                                            </MDTypography>
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={1}>
                                    <FormField
                                        type="text"
                                        label="Carrier"
                                        value={selectedCarrier}
                                        disabled // Kullanıcı değiştiremez, sadece görüntülenir
                                    />
                                </Grid>
                                {/* Search Butonu Her Zaman Görünecek */}
                                <Grid container spacing={3} alignItems="center" justifyContent="flex-end">
                                    <Grid item>
                                        <IconButton onClick={() => setModalOpen(true)}
                                                    style={{backgroundColor: "#007BFF", color: "#fff"}}>
                                            <SearchIcon/>
                                        </IconButton>
                                    </Grid>
                                </Grid>

                                <>
                                    {/* 📌 TOTAL DEĞERLERİN GÖSTERİLDİĞİ KISIM */}
                                    <Grid container spacing={3} alignItems="center">
                                        {[
                                            {label: "Total Unit Quantity", field: "unitQuantity"},
                                            {label: "Total Volume (m³)", field: "volume"},
                                            {label: "Total CBM", field: "cbm"},
                                            {label: "Total LDM", field: "ldm"},
                                            {label: "Total Gross Weight", field: "grossWeight"},
                                            {label: "Total Chargeable Weight (kg)", field: "chargeableWeight"},
                                        ].map(({label, field}) => (
                                            <Grid item xs={12} sm={4} key={field}>
                                                <FormField label={label}
                                                           value={cargoDetails.reduce((sum, c) => sum + (parseFloat(c[field]) || 0), 0)}
                                                           disabled/>
                                            </Grid>
                                        ))}

                                    </Grid>

                                    {/* 📌 POPUP / MODAL */}
                                    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                                        <div
                                            style={{
                                                background: "white",
                                                padding: "20px",
                                                borderRadius: "8px",
                                                width: "800px",
                                                margin: "100px auto",
                                                maxHeight: "80vh",
                                                overflowY: "auto",
                                            }}
                                        >
                                            <h5>Cargo Details</h5>

                                            {tempCargoDetails.map((cargo, index) => (
                                                <Grid container spacing={2} key={index} alignItems="center"
                                                      style={{padding: "15px", borderBottom: "1px solid #ddd"}}>

                                                    {/* 📌 Cargo Başlığı ve Silme Butonu */}
                                                    <Grid item xs={12} style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    }}>
                                                        <MDTypography variant="h6" fontWeight="bold" color="primary">
                                                            Cargo {index + 1}
                                                        </MDTypography>
                                                        <IconButton
                                                            onClick={() => setTempCargoDetails(tempCargoDetails.filter((_, i) => i !== index))}
                                                            style={{
                                                                backgroundColor: "#DC3545",
                                                                color: "#fff",
                                                                width: "40px",
                                                                height: "40px"
                                                            }}
                                                        >
                                                            <DeleteIcon/>
                                                        </IconButton>
                                                    </Grid>

                                                    {/* 📌 Form Alanları */}
                                                    {[
                                                        {label: "Unit Quantity", field: "unitQuantity"},
                                                        {label: "Width (cm)", field: "width"},
                                                        {label: "Length (cm)", field: "length"},
                                                        {label: "Height (cm)", field: "height"},
                                                        {label: "Gross Weight (kg)", field: "grossWeight"},
                                                    ].map(({label, field}) => (
                                                        <Grid item xs={4} key={field}>
                                                            <FormField
                                                                type="number"
                                                                label={label}
                                                                value={cargo[field]}
                                                                onChange={(e) => updateCargoDetails(index, field, parseFloat(e.target.value))}
                                                            />
                                                        </Grid>
                                                    ))}

                                                    {/* 📌 Stackable Switch */}
                                                    <Grid item xs={4}>
                                                        <MDBox display="flex" alignItems="center">
                                                            <MDTypography variant="button" fontWeight="regular"
                                                                          color="text">
                                                                {cargo.notStackable ? "Not Stackable" : "Stackable"}
                                                            </MDTypography>
                                                            <Switch
                                                                checked={!cargo.notStackable}
                                                                onChange={() =>
                                                                    updateCargoDetails(index, "notStackable", !cargo.notStackable)
                                                                }
                                                            />
                                                        </MDBox>
                                                    </Grid>

                                                    {/* 📌 Stacking Factor (Sadece Stackable ise görünür) */}
                                                    {!cargo.notStackable && (
                                                        <Grid item xs={12} sm={4}>
                                                            <FormField
                                                                type="number"
                                                                label="Stacking Factor"
                                                                placeholder="Stacking Factor"
                                                                value={cargo.stackingFactor}
                                                                onChange={(e) => {
                                                                    const value = parseInt(e.target.value, 10);
                                                                    updateCargoDetails(
                                                                        index,
                                                                        "stackingFactor",
                                                                        value >= 0 ? value : 0,
                                                                    );
                                                                }}
                                                            />
                                                        </Grid>
                                                    )}

                                                    {/* 📌 Hesaplanan Alanlar */}
                                                    {[
                                                        {label: "Volume (m³)", field: "volume"},
                                                        {label: "CBM", field: "cbm"},
                                                        {label: "LDM", field: "ldm"},
                                                        {label: "Chargeable Weight (CW)", field: "chargeableWeight"},
                                                    ].map(({label, field}) => (
                                                        <Grid item xs={4} key={field}>
                                                            <FormField label={label} value={cargo[field]} disabled/>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            ))}

                                            {/* 📌 Butonlar */}
                                            <Grid container justifyContent="flex-end" spacing={2} mt={2}>
                                                <Grid item>
                                                    <Button
                                                        startIcon={<AddIcon/>}
                                                        onClick={() => setTempCargoDetails([...tempCargoDetails, {
                                                            unitQuantity: "",
                                                            width: "",
                                                            length: "",
                                                            height:"",
                                                            volume: 0,
                                                            cbm: 0,
                                                            ldm: 0,
                                                            grossWeight: "",
                                                            chargeableWeight: 0,
                                                            stackingFactor: 1,
                                                            notStackable: true
                                                        }])}
                                                        style={{backgroundColor: "#0B1F3A", color: "#FFFFFF"}}
                                                    >
                                                        Add Row
                                                    </Button>
                                                </Grid>

                                                <Grid item>
                                                    <Button
                                                        startIcon={<ClearIcon/>}
                                                        onClick={() => setTempCargoDetails([])}
                                                        style={{backgroundColor: "#DC3545", color: "#fff"}}
                                                    >
                                                        Clear All
                                                    </Button>
                                                </Grid>

                                                <Grid item>
                                                    <Button
                                                        startIcon={<SaveIcon/>}
                                                        onClick={() => {
                                                            setCargoDetails([...tempCargoDetails]); // Verileri kaydet
                                                            setModalOpen(false); // Popup'ı kapat
                                                        }}
                                                        style={{backgroundColor: "#007BFF", color: "#fff"}}
                                                    >
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Modal>                        </>


                                {/* Pickup Address */}
                                <MDBox mt={3}>
                                    <MDTypography variant="h6">Pickup Location</MDTypography>
                                </MDBox>
                                <Grid item xs={12}>
                                    <FormField
                                        type="text"
                                        label="Additional Pickup Address Info"
                                        placeholder="Enter additional information"
                                        value={pickupLocation.additionalInfo}
                                        onChange={(e) =>
                                            handleStateChange(
                                                setPickupLocation,
                                                "additionalInfo",
                                                e.target.value,
                                            )
                                        }
                                    />
                                </Grid>
                                <MDBox mt={2}>
                                    <Grid container spacing={3}>
                                        {/* Country Selection */}
                                        <Grid item xs={12} sm={6}>
                                            <Autocomplete
                                                value={selectedCountry} // Seçili ülke gösterilecek
                                                onChange={(event, newValue) => handleCountryChange(newValue)}
                                                options={filteredCountryOptions}
                                                getOptionLabel={(option) => option.label || ""}
                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                    <li key={optionKey} {...props} style={{display: "flex", alignItems: "center"}}>
                                                        {option.flagUrl && (
                                                            <img
                                                                src={option.flagUrl}
                                                                alt={`${option.label} flag`}
                                                                width="20"
                                                                height="15"
                                                                style={{marginRight: "8px"}}
                                                            />
                                                        )}
                                                        {option.label}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <MDInput {...params} variant="standard"
                                                             label="Select Destination Country"/>
                                                )}
                                            />
                                        </Grid>

                                        {/* Zipcode Input */}
                                        <Grid item xs={12} sm={6}>
                                            <Autocomplete
                                                options={zipcodeOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={
                                                    pickupLocation.zipcode
                                                        ? {label: pickupLocation.zipcode}
                                                        : null
                                                }
                                                onChange={(event, value) =>
                                                    handleZipcodeSelect(
                                                        value,
                                                        setPickupLocation,
                                                        setIsZipcodeListOpen,
                                                        setShowAddressDetails
                                                    )
                                                }
                                                open={isZipcodeListOpen}
                                                onOpen={() => setIsZipcodeListOpen(true)}
                                                onClose={() => setIsZipcodeListOpen(false)}
                                                renderInput={(params) => (
                                                    <MDInput
                                                        variant="standard"
                                                        {...params}
                                                        label={`Enter 2 Digits Zipcode ${zipcodeError ? "(Not Found)" : ""}`}
                                                        placeholder="Enter 2 Digits Zipcode"
                                                        onChange={(e) =>
                                                            handleZipcodeChange(
                                                                e,
                                                                selectedCountry,
                                                                setPickupLocation,
                                                                setZipcodeOptions,
                                                                setZipcodeError,
                                                                setIsZipcodeListOpen
                                                            )
                                                        }
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </MDBox>


                                <MDBox mt={3}>
                                    <Grid container spacing={3} alignItems="center">
                                        {/* Country */}
                                        <Grid item xs={12} sm={6}>
                                            <FormField
                                                type="text"
                                                label="Country"
                                                placeholder="Enter Country"
                                                value={pickupLocation.country || ""}
                                                onChange={(e) =>
                                                    setPickupLocation((prev) => ({...prev, country: e.target.value}))
                                                }
                                            />
                                        </Grid>

                                        {/* Zone */}
                                        <Grid item xs={12} sm={2}>
                                            <MDTypography variant="h6" color="warning">
                                                <span style={{color: "black"}}>Zone: </span>
                                                <strong>{calculatedZone}</strong>
                                            </MDTypography>
                                        </Grid>

                                        {/* Rate */}
                                        <Grid item xs={12} sm={3}>
                                            <MDTypography variant="h6">
                                                <span style={{color: "black"}}>Rate: </span>
                                                <strong>
                                                  <span style={{color: "green"}}>
                                                    {Math.round(calculatedRate).toLocaleString("tr-TR")} EUR
                                                  </span>
                                                </strong>
                                            </MDTypography>
                                        </Grid>

                                    </Grid>
                                </MDBox>
                                <br/> <br/>
                                <Grid container spacing={2} justifyContent="center" alignItems="center">
                                    {/* Mersin için toplam maliyet */}
                                    <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
                                        <MDTypography variant="h6" sx={{fontWeight: "bold"}}>
                                            Mersin to {calculatedZone} of
                                            the {pickupLocation.country} Total Cost:
                                            <span style={{color: "green", fontWeight: "bold", marginLeft: "8px"}}>
                {isNaN(totalCostMersin) || totalCostMersin === null || totalCostMersin === undefined
                    ? "N/A"
                    : Math.round(totalCostMersin).toLocaleString("tr-TR")} {mersinPickupLocation.currency || "EUR"}
            </span>
                                        </MDTypography>
                                    </Grid>

                                </Grid>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                    <div>
                        <form onSubmit={submitHandler}>
                            <Button
                                variant="contained"
                                onClick={submitHandler}
                                style={{backgroundColor: "#0B1F3A", color: "#FFFFFF"}}
                            >
                                {isEditing ? "Update Control Tower Tool" : "Create Control Tower Tool"}{" "}
                            </Button>
                        </form>
                    </div>
                </MDBox>
        </Grid>
        </Grid>

    );
};


export default Sultantur;
